import {GetResource} from "../utils/HttpUtil";

export function LoadBanners(name) {
    return GetResource(`/bannergroups/${name}`);
}

export function LoadTopWinners() {
    return GetResource(`/topWinners`);
}
